import { Inject, Directive, Input, OnDestroy, Optional, Output, EventEmitter } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/**
 * This directive add an input file select behavior by binding itself to the click event of it's host element.
 */
@Directive({
  selector: '[sgFileInput]',
  host: {
    '(click)': `onClick($event)`,
    '[attr.data-test]': 'dataTest',
  },
  standalone: false,
})
export class SgFileInputDirective implements OnDestroy {
  @Input() set multiple(value: boolean) {
    if (this.input) {
      if (value != null && `${value}` !== 'false') {
        this.input.setAttribute('multiple', 'true');
      } else {
        this.input.removeAttribute('multiple');
      }
    }
  }

  @Input() set accept(value: string) {
    if (this.input) {
      if (value) {
        this.input.setAttribute('accept', value);
      } else {
        this.input.removeAttribute('accept');
      }
    }
  }

  @Output('sgFileInput') change = new EventEmitter<FileList | null>();

  @Input('data-test') set dataTestAttr(value: string) {
    this.dataTest = value;
    if (this.input) {
      if (value) {
        this.input.setAttribute('data-test', value + '_input');
      } else {
        this.input.removeAttribute('data-test');
      }
    }
  }

  protected dataTest: string;
  private input: HTMLInputElement;
  private listener: (ev: Event) => void;

  constructor(@Optional() @Inject(DOCUMENT) document: HTMLDocument) {
    if (document) {
      const input = (this.input = document.createElement('input'));
      input.setAttribute('type', 'file');

      input.setAttribute('hidden', 'true');
      document.body.appendChild(input);

      this.listener = (ev: Event) => {
        this.change.emit(this.input.files);
        this.input.value = '';
      };
      input.addEventListener('change', this.listener);
    }
  }

  onClick(event: MouseEvent): void {
    if (this.input) {
      this.input.dispatchEvent(new MouseEvent(event.type, event));
    }
  }

  ngOnDestroy(): void {
    if (this.input) {
      this.input.removeEventListener('change', this.listener);
      this.input.remove();
    }
  }
}
